// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.description-info {
  margin-top: 1rem; }
  .description-info .info-card {
    min-height: 175px !important;
    background-color: #1e2930;
    border: 2px solid #34575f;
    border-radius: 15px; }
    .description-info .info-card h5 {
      color: #8edef5;
      font-weight: 500;
      font-size: 16px; }
    .description-info .info-card .info-row {
      font-weight: 400;
      font-weight: 400;
      font-size: 12px;
      padding-top: 0.5em;
      padding-bottom: 0.5em;
      color: white; }
  .description-info .description {
    height: 100%; }
    .description-info .description .edit-button {
      transition: all 0.3s ease-in-out; }
      .description-info .description .edit-button:hover {
        color: white;
        cursor: pointer; }
    .description-info .description .confirm-btn {
      min-width: 75px;
      font-family: MyriadPro;
      letter-spacing: 0.05em;
      font-weight: 700;
      font-size: 14px;
      color: #23434b;
      background: #4bc0d3;
      padding: 2px 10px;
      margin: 0 5px;
      border-radius: 8px;
      border: none; }
      .description-info .description .confirm-btn:enabled {
        color: #23434b; }
      .description-info .description .confirm-btn:hover {
        background: #4bc0d3 !important;
        color: #fefefe; }
      .description-info .description .confirm-btn:disabled {
        background: #5c666f;
        color: #202932; }

.section-header {
  font-family: MyriadPro;
  letter-spacing: 0.05em;
  background-color: #31545a;
  color: white;
  border-radius: 5px;
  font-size: 12px;
  display: inline-block;
  padding: 0.5em 2em;
  margin-bottom: 5px; }

.deployments {
  margin-top: 2em; }

.proofs {
  margin-top: 2em; }

.avatar {
  width: 64px;
  height: 64px; }

.title {
  font-weight: 500;
  font-size: 1.5rem; }

.image-detail-table {
  margin-top: 20px !important; }

.page-header {
  color: white;
  vertical-align: bottom;
  border-bottom: 4px solid #2b8196;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 20px; }
  .page-header .image-heading {
    font-weight: 500;
    font-size: 20px; }
  .page-header .image-hash {
    font-weight: 500;
    font-size: 18px; }
  .page-header .user-address {
    font-weight: 500;
    font-size: 18px; }

.download-button {
  background: #4bc0d3;
  border-radius: 8px;
  border: none;
  color: #23434b;
  font-family: MyriadPro;
  letter-spacing: 0.05em;
  font-weight: 700;
  font-size: 14px;
  padding: 4px 10px;
  margin-left: 5px;
  cursor: pointer; }
  .download-button:hover {
    background: #4bc0d3 !important;
    color: #fefefe; }

.download-error {
  color: #ff0000;
  font-size: 12px;
  margin-left: 5px;
  margin-bottom: 5px; }
`, "",{"version":3,"sources":["webpack://./src/components/ImageDetail/style.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB,EAAA;EADlB;IAGI,4BAA4B;IAC5B,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB,EAAA;IANvB;MAQM,cAAc;MACd,gBAAgB;MAChB,eAAe,EAAA;IAVrB;MAcM,gBAAgB;MAChB,gBAAgB;MAChB,eAAe;MACf,kBAAkB;MAClB,qBAAqB;MACrB,YAAY,EAAA;EAnBlB;IAuBI,YAAY,EAAA;IAvBhB;MAyBM,gCAAgC,EAAA;MAzBtC;QA2BQ,YAAY;QACZ,eAAe,EAAA;IA5BvB;MAgCM,eAAe;MACf,sBAAsB;MACtB,sBAAsB;MACtB,gBAAgB;MAChB,eAAe;MACf,cAAc;MACd,mBAAmB;MACnB,iBAAiB;MACjB,aAAa;MACb,kBAAkB;MAClB,YAAY,EAAA;MA1ClB;QA4CQ,cAAc,EAAA;MA5CtB;QA+CQ,8BAA8B;QAC9B,cAAc,EAAA;MAhDtB;QAmDQ,mBAAmB;QACnB,cAAc,EAAA;;AAMtB;EACE,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,eAAe,EAAA;;AAEjB;EACE,eAAe,EAAA;;AAEjB;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,gBAAgB;EAChB,iBAAiB,EAAA;;AAOnB;EACE,2BAA2B,EAAA;;AAG7B;EACE,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;EAPjB;IAUI,gBAAgB;IAChB,eAAe,EAAA;EAXnB;IAcI,gBAAgB;IAChB,eAAe,EAAA;EAfnB;IAkBI,gBAAgB;IAChB,eAAe,EAAA;;AAInB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe,EAAA;EAXjB;IAaI,8BAA8B;IAC9B,cAAc,EAAA;;AAIlB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAA","sourcesContent":[".description-info {\n  margin-top: 1rem;\n  .info-card {\n    min-height: 175px !important;\n    background-color: #1e2930;\n    border: 2px solid #34575f;\n    border-radius: 15px;\n    h5 {\n      color: #8edef5;\n      font-weight: 500;\n      font-size: 16px;\n    }\n\n    .info-row {\n      font-weight: 400;\n      font-weight: 400;\n      font-size: 12px;\n      padding-top: 0.5em;\n      padding-bottom: 0.5em;\n      color: white;\n    }\n  }\n  .description {\n    height: 100%;\n    .edit-button {\n      transition: all 0.3s ease-in-out;\n      &:hover {\n        color: white;\n        cursor: pointer;\n      }\n    }\n    .confirm-btn {\n      min-width: 75px;\n      font-family: MyriadPro;\n      letter-spacing: 0.05em;\n      font-weight: 700;\n      font-size: 14px;\n      color: #23434b;\n      background: #4bc0d3;\n      padding: 2px 10px;\n      margin: 0 5px;\n      border-radius: 8px;\n      border: none;\n      &:enabled {\n        color: #23434b;\n      }\n      &:hover {\n        background: #4bc0d3 !important;\n        color: #fefefe;\n      }\n      &:disabled {\n        background: #5c666f;\n        color: #202932;\n      }\n    }\n  }\n}\n\n.section-header {\n  font-family: MyriadPro;\n  letter-spacing: 0.05em;\n  background-color: #31545a;\n  color: white;\n  border-radius: 5px;\n  font-size: 12px;\n  display: inline-block;\n  padding: 0.5em 2em;\n  margin-bottom: 5px;\n}\n\n.deployments {\n  margin-top: 2em;\n}\n.proofs {\n  margin-top: 2em;\n}\n.avatar {\n  width: 64px;\n  height: 64px;\n}\n\n.title {\n  font-weight: 500;\n  font-size: 1.5rem;\n}\n\n// .image-container {\n//   max-width: 1450px !important;\n// }\n\n.image-detail-table {\n  margin-top: 20px !important;\n}\n\n.page-header {\n  color: white;\n  vertical-align: bottom;\n  border-bottom: 4px solid #2b8196;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n\n  .image-heading {\n    font-weight: 500;\n    font-size: 20px;\n  }\n  .image-hash {\n    font-weight: 500;\n    font-size: 18px;\n  }\n  .user-address {\n    font-weight: 500;\n    font-size: 18px;\n  }\n}\n\n.download-button {\n  background: #4bc0d3;\n  border-radius: 8px;\n  border: none;\n  color: #23434b;\n  font-family: MyriadPro;\n  letter-spacing: 0.05em;\n  font-weight: 700;\n  font-size: 14px;\n  padding: 4px 10px;\n  margin-left: 5px;\n  cursor: pointer;\n  &:hover {\n    background: #4bc0d3 !important;\n    color: #fefefe;\n  }\n}\n\n.download-error {\n  color: #ff0000;\n  font-size: 12px;\n  margin-left: 5px;\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
